export const SearchMethodsvalues = {
  CONTAINS: "contains",
  EQUAL: "equal",
  STARTSWITH: "startswith",
  ENDSWITH: "endswith",
} as const;

export const SearchOperatorsvalues = {
  AND: "and",
  OR: "or"
} as const;

export type SearchMethods = typeof SearchMethodsvalues[keyof typeof SearchMethodsvalues];
export type SearchOperators = typeof SearchOperatorsvalues[keyof typeof SearchOperatorsvalues];